import React from "react";
import { ContentLayout, Box, SpaceBetween } from "@cloudscape-design/components";
import { Button } from "../Button";

interface ErrorScreenProps {
  title: string;
  message: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title,
  message,
  buttonText = "Go Back",
  onButtonClick
}) => (
  <ContentLayout defaultPadding>
    <Box textAlign="center" color="inherit">
      <SpaceBetween direction="vertical" size="m">
        <Box variant="strong" textAlign="center" color="inherit">
          {title}
        </Box>
        <Box variant="p" textAlign="center" color="inherit">
          {message}
        </Box>
        {onButtonClick && (
          <Box textAlign="center">
            <Button variant="primary" onClick={onButtonClick}>
              {buttonText}
            </Button>
          </Box>
        )}
      </SpaceBetween>
    </Box>
  </ContentLayout>
);
